import { myIcons } from "@/utils/icons";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { message } from 'antd';

export const Projects = () => {
    const { t } = useTranslation();
    const [messageApi, contextHolder] = message.useMessage();
    const projects = t("projects", { returnObjects: true }) as any[];
    return <div
        style={{
            color: 'var(--color-text)'
        }}
    >
        <p
            style={{
                fontSize: '25px',
                marginBottom: '20px',
            }}
        >{t("projects-title")}</p>

        <div
            className="projects-grid"
            style={{
                display: 'grid', gap: '10px'
            }} >
            {projects.map((p) => (
                <Link
                    key={p.id}
                    to={`/project/${p.id}`}
                    style={{ textDecoration: "none", color: "inherit" }}
                    onClick={(e) => {
                        if (p.id === 2 || p.id === 8) {
                            e.preventDefault(); // Linkin gitmesini engelle
                            messageApi.open({
                                type: 'info',
                                content: t('projectCannotOpenAlert'),
                            });
                        }
                    }}
                >
                    {contextHolder}
                    <ProjectsItem icon={myIcons.projects[p.icon as keyof typeof myIcons.projects]} title={p.title} type={p.type} topic={p.topic} date={p.date} persons={p.persons} state={p.state} />
                </Link>
            ))}
        </div>
    </div>;
}

interface ProjectsItemPropsI {
    icon: string;
    title: string;
    date: string;
    type: string;
    topic: string;
    persons: number;
    state: string;
}

const ProjectsItem = ({ icon, title, date, type, topic, persons, state }: ProjectsItemPropsI) => {
    return <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.3, ease: "linear" }}
        whileHover={{
            scale: 1.02,
            boxShadow: "0px 5px 10px rgba(0,0,0,0.15)",
        }}
        style={{
            display: 'flex',
            flexDirection: 'column',
            border: '2px solid #9e9e9e',
            borderRadius: '10px',
            boxShadow: '0px 2px 0px rgba(0,0,0,0.15)',
        }} >
        <div
            style={{ display: 'flex', gap: '10px', backgroundColor: '#2196f34a', borderBottom: '2px solid #9e9e9e', borderRadius: '8px 8px 0px 0px', padding: '5px' }} >
            <img
                src={icon} alt=""
                style={{ width: '40px', height: '100%' }}
            />
            <div>
                <p style={{ fontWeight: 'bold' }} >{title}</p>
                <p>{type}</p>
            </div>
        </div>

        <div style={{
            padding: '10px',
            backgroundColor: 'var(--color-bg-third)',
            borderRadius: '0px 0px 10px 10px'
        }} >
            <p style={{ color: '#9e9e9e', marginBottom: '5px' }} >Konu:</p>
            <p>{topic}</p>
            <p style={{ color: '#9e9e9e', marginBottom: '5px', marginTop: '10px' }} >Tarih:</p>
            <p>{date}</p>

            <div style={{ display: 'flex', gap: '50px', marginTop: '10px' }} >
                <div>
                    <p style={{ color: '#9e9e9e', marginBottom: '5px' }} >Kişiler:</p>
                    <div style={{ display: 'flex', border: '2px solid #9e9e9e', borderRadius: '5px', justifyContent: 'space-evenly' }} >
                        <img width={15} src={myIcons.interfaces.user} alt="" />
                        <div style={{ display: 'flex', height: 'auto', width: '1.5px', backgroundColor: '#9e9e9e' }} ></div>
                        <p>{persons}</p>
                    </div>
                </div>
                <div>
                    <p style={{ color: '#9e9e9e', marginBottom: '5px' }} >Durum:</p>
                    <p style={{ backgroundColor: '#4caf501a', color: '#4caf50', padding: '2px', borderRadius: '5px' }} >{state}</p>
                </div>
            </div>
        </div>
    </motion.div>;
}